var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColapseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.665,
    height: 16.971,
    viewBox: "0 0 7.665 16.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Colapse_icon",
    "data-name": "Colapse icon",
    transform: "translate(-7.693 8.485) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758",
    transform: "translate(2.15 2.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M7.355,17.972a.616.616,0,0,1-.616-.616V14.383H3.766a.616.616,0,1,1,0-1.233H7.355a.616.616,0,0,1,.616.616v3.589A.616.616,0,0,1,7.355,17.972Z",
    transform: "translate(-2.552 -6.57)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M17.355,7.972H13.766a.616.616,0,0,1-.616-.616V3.766a.616.616,0,1,1,1.233,0V6.739h2.973a.616.616,0,1,1,0,1.233Z",
    transform: "translate(-6.57 -2.552)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M13.766,7.57a.616.616,0,0,1-.436-1.052l4.187-4.187a.616.616,0,0,1,.872.872L14.2,7.389A.614.614,0,0,1,13.766,7.57Z",
    transform: "translate(-6.57 -2.15)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M2.766,18.57a.616.616,0,0,1-.436-1.052l4.187-4.187a.616.616,0,0,1,.872.872L3.2,18.389A.614.614,0,0,1,2.766,18.57Z",
    transform: "translate(-2.15 -6.57)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColapseicon);
export default __webpack_public_path__ + "static/media/Colapse icon.4d5f9f4ef54c262fbda3447c66427bbc.svg";
export { ForwardRef as ReactComponent };